const OFFICE_MIME_TYPES = new Set([
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
]);

const OFFICE_EXTENSIONS = [".doc", ".docx", ".xls", ".xlsx", ".ppt", ".pptx"];
const WORD_EXTENSIONS = [".docx"];

import { apiUrl } from "../environmentConfig";

export function isWordDocument(file) {
  const type = file?.file_type || file?.mime_type || "";
  const name = (file?.file_name || "").toLowerCase();

  return (
    type ===
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
    WORD_EXTENSIONS.some((ext) => name.endsWith(ext))
  );
}

export function isOfficeDocument(file) {
  const type = file?.file_type || file?.mime_type || "";
  const name = (file?.file_name || "").toLowerCase();

  if (OFFICE_MIME_TYPES.has(type)) {
    return true;
  }

  return OFFICE_EXTENSIONS.some((ext) => name.endsWith(ext));
}

export function getPublicFileUrl(file) {
  return file?.file_url || file?.url || null;
}

export function getDownloadUrl(file) {
  if (file?.file_id) {
    return `${apiUrl}/file/download/${file.file_id}`;
  }

  if (file?.download_url) {
    return file.download_url;
  }

  const url = getPublicFileUrl(file);
  if (!url) {
    return null;
  }

  const fileName = file?.file_name || "download";

  if (
    url.includes("res.cloudinary.com") &&
    url.includes("/upload/") &&
    !url.includes("/fl_attachment")
  ) {
    const attachment = `fl_attachment:${fileName}`;
    return url.replace("/upload/", `/upload/${attachment}/`);
  }

  return url;
}

export function getPreviewSource(file) {
  const publicUrl = getPublicFileUrl(file);
  const previewUrl = file?.previewUrl || file?.preview_url;

  if (file?.file_type === "text/html") {
    return `${apiUrl}/file/stream/${file.file_id}`;
  }

  if (isOfficeDocument(file)) {
    return publicUrl || (previewUrl?.startsWith("blob:") ? null : previewUrl);
  }

  return previewUrl || publicUrl;
}
